import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import moment from 'moment';
import { ReleaseMgmtService } from '@app/shared/services/releaseMgmtService';
import { ActivatedRoute } from '@angular/router';
import { ICellRendererParams, IColumnToolPanel } from 'ag-grid-community';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CSListDto } from '@app/apiModules/CSList';
import { AgGridConfigurationService } from '@app/shared/services/ag-grid-configuration.service';
import { MenuContextualService } from '@app/shared/services/menu-contextual.service';
import { ColDef, ColumnApi, GridOptions, RowModelType, ServerSideStoreType } from 'ag-grid-community';
import { LazyLoadEvent } from 'primeng/api';
import { LoaderService } from '@app/shared/services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { ConstantsService } from '@app/common/constants.service';
import { CommonModule } from '@angular/common';
import { AddModifyServiceConfigComponent } from './add-modify-service-config/add-modify-service-config.component';
import { SliderComponent } from '@app/shared/shared-components/slider/slider.component';
import { GithubDetailsComponent } from '../../github-details/github-details.component';
import { UserAuthService } from '@app/shared/services/user-auth.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  standalone: true,
  selector: 'app-services-list',
  templateUrl: './services-list.component.html',
  styleUrls: ['./services-list.component.scss'],
  imports:[CommonModule,AddModifyServiceConfigComponent,SliderComponent,AgGridModule,MatTooltipModule,MatIconModule]
})
export class ServicesListComponent {

  @ViewChild('agGrid') agGrid: AgGridAngular;
  releaseId: number = 0;
  infiniteInitialRowCount =30;
  paginationPageSize = 10;//[10, 20, 30, 40, 50];
  overlayNoRowsTemplate = `<span style="font-weight: 400; color: #757575; ">No records found</span>`;
  rowData: CSListDto[] = [];
  filteredRowData: CSListDto[] = [];
  serverSideStoreType: ServerSideStoreType = "partial";
  rowModelType: RowModelType = 'serverSide';
  cacheBlockSize = 100;
  rowHeight = 42;
  styleChipDiv = "height: calc(100vh - 260px); flex: 1 1 auto; border: 1px solid #DFDFDF;";
  sideBar = true;
  serviceSliderId: string = "addEditServiceSlider";
  editmode = false;
  sliderDescription: string = "Add / Modify Service Configuration";
  maxBlocksInCache = 10;
 
  releaseTitle: string = '';
  columnDefs: any;
  agGridColDef: any;

    public defaultColDef :ColDef= {
    flex: 1, filter: true, sortable: true, resizable: true,
    floatingFilter: false,
    enableRowGroup: true,
    enableValue: true,
  };
  gridOptions: { onBodyScroll: true; onCellClicked: any; getServerSideStoreParams: (params: any) => { cacheBlockSize: number; maxBlocksInCache: number; }; };

  gridDataParams: any;
  api: any;
  public gridColumnApi!: ColumnApi;
  loading: boolean;
  agGridRowData: any;
  totalRecords: any;
  selectedServiceId: string;
  selectedService: CSListDto;
  allServices: any;

  constructor( public constantsService: ConstantsService, public loader: LoaderService, public toastr: ToastrService, public contextMenu: MenuContextualService, public viewContainerRef: ViewContainerRef, public agGridConfigurationService: AgGridConfigurationService, private ReleaseMgmtService: ReleaseMgmtService, public route: ActivatedRoute, public dialog: MatDialog,
    public readonly userAuthService: UserAuthService
  ) { }

  
  ngOnInit(): void {
    this.setAgGridCol();
  }
    
  setAgGridCol() {
    this.agGridColDef = {
      tableName: "tableName",
      column: [
      { 
        columnName: 'serviceName', 
        headerName: 'Service Name', 
        filter: 'agSetColumnFilter',
        filterParams: {
        buttons: ['clear'],
        suppressSorting: false,
        caseSensitive: false,
        suppressSelectAll: false,
        suppressMiniFilter: false,
        },
        flex: 1, 
        minWidth: 280,
        maxWidth: 360
      },
      {
        headerName: 'API',
        columnName: 'hasAPI',
        filter: 'agSetColumnFilter', 
        filterParams: {
        values: [true, false],
        buttons: ['clear'],
        suppressSorting: true,
        valueFormatter: (params) => params.value == 'true' ? 'Yes' : 'No' 
        },
        flex: 1,
        minWidth: 180,
        maxWidth: 360,
        cellRenderer: (params: ICellRendererParams) => params.value == true ? 'Yes' : 'No',
        tooltipValueGetter: (params: ICellRendererParams) => params.value == true ? 'Yes' : 'No'
      },
      {
        headerName: 'Web',
        columnName: 'hasWeb',
        filter: 'agSetColumnFilter', 
        filterParams: {
        values: [true, false],
        buttons: ['clear'],
        suppressSorting: true,
        valueFormatter: (params) => params.value == 'true' ? 'Yes' : 'No' 
        },
        flex: 1,
        minWidth: 180,
        maxWidth: 360,
        cellRenderer: (params: ICellRendererParams) => params.value == true ? 'Yes' : 'No',
        tooltipValueGetter: (params: ICellRendererParams) => params.value == true ? 'Yes' : 'No'
      },
      {
        headerName: 'Status',
        columnName: 'status',
        filter: 'agSetColumnFilter',
        filterParams: {
        values: [0, 1, 2],
        valueFormatter: (params) => {
          if (params.value === 1 || params.value === '1' ) return 'Active';
          if (params.value === 0 || params.value === '0') return 'Inactive';
          if (params.value === 2 || params.value === '2') return 'Inactive For Future Release';
          return String(params.value);
        },
        buttons: ['clear'],
        suppressSorting: false,
        caseSensitive: false,
        suppressSelectAll: false,
        suppressMiniFilter: false,
        },
        flex: 1,
        minWidth: 200,
        maxWidth: 400,
        tooltipValueGetter: params => {
        if (params.value == 1) {
          return 'Active';
        }
        if (params.value == 0) {
          return 'Inactive';
        }
        if (params.value == 2) {
          return 'Inactive For Future Release';
        }
        return String(params.value);
        },
        cellRenderer: params => {
        const btnStyle = `
          display: inline-flex;
          align-items: center;
          justify-content: center;
          height: 22px;
          min-width: 120px;
          padding: 0 6px;
          border-radius: 12px;
          font-weight: 500;
          cursor: default;
          white-space: nowrap;
          border: none;
          box-shadow: 0 1px 2px rgba(60,60,60,0.07);
        `;
        if (params.value === 1 || params.value === 'Active') {
          return `<span style="${btnStyle} background: #c7ecd2ff; color: #01581aff; border: none;">Active</span>`;
        }
        if (params.value === 0 || params.value === 'Inactive') {
          return `<span style="${btnStyle} background: #FFE0B2; color: #d84901ff; border: none;">Inactive</span>`;
        }
        if (params.value === 2 || params.value === 'Inactive For Future Release') {
          return `<span style="${btnStyle} background: #FFE0B2; color: #d84901ff; border: none;">Inactive For Future Release</span>`;
        }
        return `<span>${params.value}</span>`;
        }
      },
      { columnName: 'lastUpdatedBy', headerName: 'Last Updated By', filter: true, flex: 1, minWidth: 280, maxWidth: 460 },
      {
        columnName: 'lastUpdatedDateTime',
        dataType: "date",
        headerName: 'Last Updated On',
        field: 'lastUpdatedDateTime',
        filter: 'agDateColumnFilter',
        minWidth: 280, maxWidth: 460,
        flex: 1,
        filterParams: {
        buttons: ['clear'],
        filterOptions: ['equals'],
        defaultOption: 'equals',
        suppressAndOrCondition: true,
        comparator: (filterLocalDateAtMidnight: Date, cellValue: string | Date | undefined) => {
          if (!cellValue) return -1;
          const cellDate = new Date(cellValue);
          if (
          cellDate.getFullYear() === filterLocalDateAtMidnight.getFullYear() &&
          cellDate.getMonth() === filterLocalDateAtMidnight.getMonth() &&
          cellDate.getDate() === filterLocalDateAtMidnight.getDate()
          ) {
          return 0;
          }
          return -1;
        }
        },
        tooltipValueGetter: (params: ICellRendererParams) => {
        return params.value ? moment(params.value).format('MMM DD, YYYY, HH:mm A') : '';
        },
        cellRenderer: (params: ICellRendererParams) => {
        return params.value ? moment(params.value).format('MMM DD, YYYY, HH:mm A') : '';
        }
      },
      {
        columnName: "ACTION",
        headerName: "Action",
        dataType: "string",
        columnType: "string",
        filter: false,
        cellStyle: { textAlign: 'left' }, // Use object for cellStyle
        flex: 1,
        minWidth: 230,
        maxWidth: 480
      }
      ]
    };
    this.rowModelType = 'clientSide';
    this.columnDefs = this.agGridConfigurationService.GetServiceConfigurationColmnDefs(this.agGridColDef);
    this.defaultColDef = {
      filter: true,
      resizable: true,
      flex: 1,
      //minWidth: 150
    };
  }

  addService(): void {
  this.editmode = false;
  setTimeout(() => {
    const slider = document.getElementById(this.serviceSliderId);
    if (slider && slider.style) {
      slider.style.width = this.constantsService.sliderWidth;
    }
  }, 1800);
}
  onGridReady = (params) => {
  if (params != undefined) {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
    
    // Load data after API is initialized
    this.loadServiceData();
    
    this.api.setSideBar(false);
    this.onResize();
    this.api?.sizeColumnsToFit();
  }
}
  loadServiceData() {
  this.setLoader();
  
  this.ReleaseMgmtService.apiGetAllServiceConfigurationDetails().subscribe({
    next: (response: CSListDto[]) => {
      this.rowData = response || [];
      this.filteredRowData = response || [];
      this.allServices = response || [];
      
      if (this.api) {
        // Set data directly to ag-Grid (like deployment status component)
        this.api.setRowData(this.filteredRowData);
        
        // Auto-size columns after data is set
        const allColumnIds: string[] = [];
        this.gridColumnApi.getAllColumns().forEach((column: any) => {
          allColumnIds.push(column.getColId());
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, false);
      }
      
      this.setUnLoader();
    },
    error: (error) => {
      console.error('Error fetching service data:', error);
      this.setUnLoader();
      this.rowData = [];
      this.filteredRowData = [];
      if (this.api) {
        this.api.setRowData([]);
      }
    }
  });
}
  setLoader() {
    this.loading = true;
    this.loader.showSpinner.next(true);
  }

  
  setUnLoader() {
    this.loading = false;
    this.loader.showSpinner.next(false);
  }

  
getGridData(event: LazyLoadEvent) {
  return {
    getRows: (params) => {
      this.api.setColumnDefs(this.columnDefs);
      this.setLoader();
        
      const filterModel = params.request.filterModel;
      const sortModel = params.request.sortModel;

      this.ReleaseMgmtService.apiGetAllServiceConfigurationDetails().subscribe({
        next: (res) => {
          let data = res || [];
          this.allServices = data;
          
          // --- Enhanced Filtering ---
          if (filterModel) {
            Object.keys(filterModel).forEach(key => {
              const filter = filterModel[key];
              if (filter) {
                data = data.filter(row => {
                  // SET FILTER handling (for serviceName and status columns)
                  if (filter.filterType === 'set' && filter.values && Array.isArray(filter.values)) {
                    return filter.values.includes(row[key]);
                  }
                  
                  // Date filter
                  if (key === 'lastUpdatedDateTime' && filter.dateFrom) {
                    const filterDate = new Date(filter.dateFrom);
                    const cellDate = new Date(row[key]);
                    return (
                      cellDate.getFullYear() === filterDate.getFullYear() &&
                      cellDate.getMonth() === filterDate.getMonth() &&
                      cellDate.getDate() === filterDate.getDate()
                    );
                  }
                  
                  // Text filter (for columns with filter: true)
                  if (typeof row[key] === 'string' && filter.filter) {
                    if (filter.type === 'contains') {
                      return row[key].toLowerCase().includes(filter.filter.toLowerCase());
                    }
                    if (filter.type === 'equals') {
                      return row[key].toLowerCase() === filter.filter.toLowerCase();
                    }
                  }
                  
                  // Number filter
                  if (typeof row[key] === 'number' && filter.filter) {
                    if (filter.type === 'equals') {
                      return row[key] === filter.filter;
                    }
                  }
                  
                  // Boolean filter
                  if (typeof row[key] === 'boolean' && filter.filter !== undefined) {
                    return row[key] === filter.filter;
                  }
                  
                  return true;
                });
              }
            });
          }

          // --- Sorting ---
          if (sortModel && sortModel.length > 0) {
            const sortCol = sortModel[0].colId;
            const sortDir = sortModel[0].sort;
            data = data.sort((a, b) => {
              if (a[sortCol] < b[sortCol]) return sortDir === 'asc' ? -1 : 1;
              if (a[sortCol] > b[sortCol]) return sortDir === 'asc' ? 1 : -1;
              return 0;
            });
          }

          // --- Pagination  ---
          const rowsThisPage = data.slice(params.request.startRow, params.request.endRow);

          if (rowsThisPage.length > 0) {
            this.agGridRowData = rowsThisPage;
            this.totalRecords = data.length;
            params.success({
              rowData: this.agGridRowData,
              rowCount: this.totalRecords,
            });
            this.api.hideOverlay();
          } else {
            params.success({ rowData: [], rowCount: 0 });
            this.api.showNoRowsOverlay();
          }
        },
        error: (err) => {
          this.toastr.error("Error while fetching data", "Error");
          this.api.showNoRowsOverlay();
        },
        complete: () => {
          this.setUnLoader();
        }
      });
    }
  };
}
  
  onResize() {
    if (!this.api) {
      setTimeout(() => {
        this.api?.refreshCells();
        this.api?.sizeColumnsToFit();
      }, 500);
      return;
    }
  }
  
  updateService(data: any) {
    this.selectedService = data;
    this.editmode = true;
    setTimeout(() => {
      document.getElementById(this.serviceSliderId).style.width = this.constantsService.sliderWidth;
    }, 1800);
  }

    
  githubDetails(data:any) {
    const dialogConfig = new MatDialogConfig(); //NOSONAR - Deprecation has been applied during migration. To remove warning, control has to be upgraded as per current version of Angular Library.
            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.height = '450px';
            dialogConfig.width = '600px';
            dialogConfig.data = {
                title: "Github Details",
                popupcontent: JSON.stringify(data)
            };
            const dialogRef = this.dialog.open(GithubDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      // handle result if needed
    });
  }
  noop() {}
    
  tableMenuClick(event, obj, _origin, _menuTemplate) {
    if (event.column.colId === "ACTION") {
      obj.allowModify = true;
      const contextObj = {
        extraProperties: obj,
        id: obj.id,
        title: obj.name,
        imgTitle: null,
        image: null,
        subTitle: obj.description,
        statusText: obj.updatedOn,
        subStatusText: "   ",
        concurrencyStamp: null,
        status: obj.status,
        tenantid: obj.tenantId,
        allowModify: obj.allowModify
      };

      this.contextMenu.open(event.event, this.viewContainerRef, contextObj, origin, _menuTemplate);
    }
  }
    
  closeNav() {
    document.getElementById(this.serviceSliderId).style.width  = this.constantsService.sliderResetWidth;
    this.refreshData();
  }
    refreshData() {
  this.loadServiceData(); // <-- Use loadServiceData instead of getGridData
}
}
